import {
  ProtectedEntitiesContainers,
  ProtectedEntitiesEPS,
  ProtectedEntitiesSVE,
  ProtectedEntityTypes,
} from '@nirvana/shared/constants';
import {ServiceTargetIds} from '../../../../targets/type';
import {Targets} from '../../../types/package-data';
import {PackageType} from '../../../packagesGrid/types';

export const VALID_ENTITIES_FOR_CUSTOM_FOLDERS = [
  ProtectedEntityTypes.EPS_CUSTOM_GROUPS,
  ProtectedEntityTypes.TYPE_EPS_CUSTOM_GROUP,
  ProtectedEntityTypes.SVE_CUSTOM_GROUPS,
  ProtectedEntityTypes.TYPE_SVE_CUSTOM_GROUP,
  ProtectedEntityTypes.TYPE_VMWARE_COLLECTION,
];

export const INVALID_ENTITIES_FOR_CUSTOM_FOLDERS = [
  ProtectedEntitiesSVE.VMWARE_COLLECTION,
  ProtectedEntitiesSVE.VMWARE_CENTER,
  ProtectedEntitiesSVE.VMWARE_DATACENTER,
  ProtectedEntitiesSVE.VMWARE_FOLDER,
  ProtectedEntitiesSVE.VMWARE_COMPUTE_RESOURCE,
  ProtectedEntitiesSVE.VMWARE_CLUSTER_COMPUTE_RESOURCE,
  ProtectedEntitiesSVE.VMWARE_RESOURCE_POOL,
  ProtectedEntitiesSVE.VMWARE_VIRTUAL_APP,
  ProtectedEntitiesSVE.VMWARE_DATASTORE,
  ProtectedEntitiesSVE.VMWARE_HOST_SYSTEM,
  ProtectedEntitiesSVE.VMWARE_STORAGE_POD,
  ProtectedEntitiesSVE.XEN_COLLECTION,
  ProtectedEntitiesSVE.XEN_SERVER,
  ProtectedEntitiesSVE.XEN_FOLDER,
  ProtectedEntitiesSVE.XEN_POOL,
  ProtectedEntitiesSVE.XEN_HOST,
  ProtectedEntitiesSVE.TYPE_EXCLUDED_FOLDER,

  ProtectedEntitiesEPS.ACTIVE_DIRECTORY,
  ProtectedEntitiesEPS.TYPE_AD_COMPUTER_GROUP,
  ProtectedEntitiesEPS.TYPE_AD_COMPUTER,
  ProtectedEntitiesEPS.TYPE_EXCLUDED_FOLDER,
  ProtectedEntitiesEPS.TYPE_AWS_GROUP,
  ProtectedEntitiesEPS.TYPE_AWS_ACCOUNT,
  ProtectedEntitiesEPS.TYPE_AWS_REGION,
  ProtectedEntitiesEPS.TYPE_AWS_INSTANCE,
  ProtectedEntitiesEPS.TYPE_AWS_AZ,

  ProtectedEntitiesEPS.TERMINATED_INSTANCES_GROUP,
  ProtectedEntitiesSVE.NUTANIX_SERVER,
  ProtectedEntitiesSVE.NUTANIX_COLLECTION,
  ProtectedEntitiesSVE.NUTANIX_CLUSTER,
  ProtectedEntitiesSVE.NUTANIX_HOST,

  ProtectedEntitiesSVE.AZURE_COLLECTION,
  ProtectedEntitiesSVE.AZURE_SERVER,
  ProtectedEntitiesSVE.AZURE_REGION,
  ProtectedEntitiesSVE.AZURE_AVAILABILITY_ZONE,

  ProtectedEntitiesSVE.AMAZON_EC2_SERVER,
  ProtectedEntitiesSVE.AMAZON_EC2_REGION,
  ProtectedEntitiesSVE.AMAZON_EC2_AZ,
  ProtectedEntitiesSVE.AMAZON_EC2_INSTANCE,
  ProtectedEntitiesSVE.AMAZON_EC2_COLLECTION,

  ProtectedEntitiesContainers.TYPE_COLLECTION,
  ProtectedEntitiesContainers.TYPE_CUSTOM_GROUPS,
  ProtectedEntitiesContainers.TYPE_FOLDER,
  ProtectedEntitiesContainers.TYPE_HOST,
];

export const PACKAGES_AVAILABLE_TARGETS = [ServiceTargetIds.EPS, ServiceTargetIds.SVE, ServiceTargetIds.CORE];

export interface Target {
  protectedEntityId?: string;
  name?: string;
  type?: number;
  path?: string;
  hasAccessToFolder?: boolean;
  notSet?: boolean;
  company?: {
    id: string;
    name: string;
  };
}

export interface SelectedTarget {
  epsFolder?: Target;
  sveFolder?: Target;
}

export interface ServiceTargets {
  serviceId: ServiceTargetIds;
  targets: Target[];
}

export const accountsNodeOptions = {
  [ServiceTargetIds.SVE]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: true,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
  [ServiceTargetIds.EPS]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: true,
    targetsMode: true,
    protectedEntitiesTypes: [
      ProtectedEntitiesEPS.ROOT,
      ProtectedEntitiesEPS.CUSTOM_GROUPS,
      ProtectedEntitiesEPS.TYPE_CUSTOM_GROUP,
    ]
  },
  [ServiceTargetIds.MDM]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: true,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
  [ServiceTargetIds.CORE]: {
    showOnlyCompanies: false,
    showOnlyManagedByAbove: false,
    showExcludedFolder: true,
    targetsMode: true,
    protectedEntitiesTypes: null,
  },
};

export interface SettingsFormViewMetadata {
  companyId: string;
  settingsFormData: SettingsFormData | null;
  packageType: PackageType;
}

export interface SettingsFormData {
  companyId: string;
  customDeployFolders: { epsFolder?: Targets; sveFolder?: Targets } | null | undefined;
  useCustomDeployFolder: boolean | undefined;
  setUninstallPassword: boolean | undefined;
  useCustomInstallationPath: boolean | undefined;
  customInstallationPath: string | undefined;
  uninstallPassword: string | undefined;
}
